module.exports = __webpack_public_path__ + "static/img/edit.4e7ae72c.svg";